import React, { useRef, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import staff_leo from '../../../assets/images/BustLeo.png';
import staff_jacko from '../../../assets/images/BustJacko.png';
import staff_sapph from '../../../assets/images/BustSapph.png';
import staff_zen from '../../../assets/images/BustZen.png';
import staff_chris from '../../../assets/images/BustChris.png';
import staff_john from '../../../assets/images/BustJohn.png';
import staff_andrew from '../../../assets/images/BustAndrew.png';
import staff_jennifer from '../../../assets/images/BustJennifer.png';

// Updated HexagonExplosion to use createPortal
const COLORS = ['#d1db4a', '#003d2d', '#00b3b9', '#517013', '#56c648', '#f9efd9'];
const HexagonExplosion = ({ x, y }) => {
  const [hexagons] = useState(() =>
    Array.from({ length: Math.floor(Math.random() * 8) + 7 }, () => ({
      id: Math.random(),
      size: Math.random() * 40 + 20,
      angle: Math.random() * Math.PI * 2,
      speed: Math.random() * 200 + 150,
      color: COLORS[Math.floor(Math.random() * COLORS.length)],
      rotation: Math.random() * 360
    }))
  );

  return createPortal(
    <div className="hexagon-explosion" style={{ left: x, top: y }}>
      {hexagons.map(hex => (
        <div
          key={hex.id}
          className="explosion-hexagon"
          style={{
            '--size': `${hex.size}px`,
            '--angle': `${hex.angle}rad`,
            '--speed': `${hex.speed}px`,
            '--color': hex.color,
            '--rotation': `${hex.rotation}deg`
          }}
        />
      ))}
    </div>,
    document.body
  );
};

const AboutStaff = () => {
  // Update the number of refs
  const cardRefs = [useRef(null), useRef(null), useRef(null), useRef(null), useRef(null), useRef(null), useRef(null), useRef(null)];
  const sectionRef = useRef(null);
  const [explosions, setExplosions] = useState({});
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 450);

  let xRotation = 0, yRotation = 0;
  
  const handleMouseMove = (event, cardRef) => {
    const { clientX, clientY } = event;
    const { top, left, width, height } = cardRef.current.getBoundingClientRect();
    const xPos = clientX - left - width / 2;
    const yPos = clientY - top - height / 2;
  
    xRotation = (yPos / (height / 2)) * -22;
    yRotation = (xPos / (width / 2)) * 27;
  
    cardRef.current.style.transform = `rotateX(${xRotation}deg) rotateY(${yRotation}deg) scale(1)`;
    cardRef.current.style.setProperty('--mouse-x', xPos + 'px');
    cardRef.current.style.setProperty('--mouse-y', yPos + 'px');
  
    if (Math.abs(xRotation) > 14 || Math.abs(yRotation) > 15) {
      cardRef.current.classList.add('shine');
    } else {
      cardRef.current.classList.remove('shine');
    }
  };
  
  const handleMouseLeave = (cardRef) => {
    cardRef.current.style.transform = 'rotateX(0deg) rotateY(0deg)';
    cardRef.current.classList.remove('shine');
    setTimeout(() => {
      cardRef.current.style.setProperty('--mouse-x', '0px');
      cardRef.current.style.setProperty('--mouse-y', '0px');
    }, 300);
  };

  // New IntersectionObserver with mobile viewport check
  useEffect(() => {
    // Check window width on mount and resize
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 450);
    };

    // Add event listener for resize
    window.addEventListener('resize', handleResize);

    // Only set up the intersection observer for non-mobile views
    if (!isMobileView) {
      const observer = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if(entry.isIntersecting) {
              cardRefs.forEach((ref, index) => {
                setTimeout(() => {
                  const card = ref.current;
                  // Updated random angle range to -10 to +10
                  const randomAngle = Math.random() * 20 - 10;
                  card.style.setProperty('--random-angle', `${randomAngle}deg`);
                  card.classList.add('fall');
                  
                  // Modified animation sequence
                  setTimeout(() => {
                    const rect = card.getBoundingClientRect();
                    const x = rect.left + rect.width / 2 + window.scrollX;
                    const y = rect.top + rect.height + window.scrollY;
                    setExplosions(prev => ({ ...prev, [index]: { x, y, id: Date.now() } }));
                    
                    card.style.opacity = '1'; // Ensure opacity stays at 1
                    const computed = window.getComputedStyle(card).transform;
                    card.classList.remove('fall');
                    card.style.setProperty('--card-transform', computed);
                    card.classList.add('scale-bounce');
                    
                    setTimeout(() => {
                      card.classList.remove('scale-bounce');
                      card.style.transform = card.style.getPropertyValue('--card-transform');
                      card.style.opacity = '1'; // Ensure opacity stays at 1 after all animations
                    }, 600);
                  }, 400);
                }, index * 200);
              });
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1, rootMargin: '0px 0px -600px 0px' } 
      );
      if (sectionRef.current) observer.observe(sectionRef.current);
      
      return () => {
        if (sectionRef.current) observer.unobserve(sectionRef.current);
      };
    } else {
      // For mobile view, just make cards visible without animations
      cardRefs.forEach(ref => {
        if (ref.current) {
          ref.current.style.opacity = '1';
          ref.current.style.transform = 'none';
        }
      });
    }

    // Clean up resize event listener
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [isMobileView]); // Re-run when isMobileView changes

  return (
    <div className='aboutus__staff-container' ref={sectionRef}>
      <div className='aboutus__staff__text '>
        <h1>Team</h1>
      </div>
      <div className='aboutus__staff'>
        <div className='aboutus__staff__column'>
          <div 
            ref={cardRefs[0]} 
            className="aboutus__staff__card tilting-card-body falling-card"
            onMouseEnter={(e) => handleMouseMove(e, cardRefs[0])} 
            onMouseMove={(e) => handleMouseMove(e, cardRefs[0])} 
            onMouseLeave={() => handleMouseLeave(cardRefs[0])}
          >
            <img src={staff_leo} alt="staff-bust-leo"/>
            <div id='staff_info'>
              <h3>Leo Cheung</h3>
              <p>Director / Lead Artist</p>
              <a href='https://x.com/BlueTwoDays' target="_blank" rel="noreferrer">
                <i className="fa-brands fa-square-x-twitter"></i> bluetwodays 
              </a>
            </div>
            {explosions[0] && <HexagonExplosion key={explosions[0].id} x={explosions[0].x} y={explosions[0].y} />}
          </div>
        </div>

        <div className='aboutus__staff__column'>
          <div 
            ref={cardRefs[1]} 
            className="aboutus__staff__card tilting-card-body falling-card"
            onMouseEnter={(e) => handleMouseMove(e, cardRefs[1])} 
            onMouseMove={(e) => handleMouseMove(e, cardRefs[1])} 
            onMouseLeave={() => handleMouseLeave(cardRefs[1])}
          >
            <img src={staff_jacko} alt="staff-bust-jacko"/>
            <div id='staff_info'>
              <h3>Jackson Michael</h3>
              <p>Lead Programer</p>
            </div>
            {explosions[1] && <HexagonExplosion key={explosions[1].id} x={explosions[1].x} y={explosions[1].y} />}
          </div>
        </div>  

        <div className='aboutus__staff__column'>
          <div 
            ref={cardRefs[2]} 
            className="aboutus__staff__card tilting-card-body falling-card"
            onMouseEnter={(e) => handleMouseMove(e, cardRefs[2])} 
            onMouseMove={(e) => handleMouseMove(e, cardRefs[2])} 
            onMouseLeave={() => handleMouseLeave(cardRefs[2])}
          >
            <img src={staff_sapph} alt="staff-bust-sapph"/>
            <div id='staff_info'>
              <h3>Sapphire Van Veen</h3>
              <p>Lead Game Designer</p>
              <a href='https://x.com/Sapphirris' target="_blank" rel="noreferrer">
                <i className="fa-brands fa-square-x-twitter"></i> Sapphirris
              </a>
            </div>
            {explosions[2] && <HexagonExplosion key={explosions[2].id} x={explosions[2].x} y={explosions[2].y} />}
          </div>
        </div>

        {/* Add new card */}
        <div className='aboutus__staff__column'>
          <div 
            ref={cardRefs[3]} 
            className="aboutus__staff__card tilting-card-body falling-card"
            onMouseEnter={(e) => handleMouseMove(e, cardRefs[3])} 
            onMouseMove={(e) => handleMouseMove(e, cardRefs[3])} 
            onMouseLeave={() => handleMouseLeave(cardRefs[3])}
          >
            <img src={staff_jennifer} alt="staff-bust-new"/>
            <div id='staff_info' style={{position: 'relative', top: '-8px'}}>
              <h3>Jennifer Reuter</h3>
              <p>Illustrator</p>
              <a href='http://www.jenareuter.com/' target="_blank" rel="noreferrer">
                <i className="fa-solid fa-globe"></i> 
                 J. Reuter Illustration
              </a>
            </div>
            {explosions[3] && <HexagonExplosion key={explosions[3].id} x={explosions[3].x} y={explosions[3].y} />}
          </div>
        </div>
      </div>
      {/* Second row */}
      <div className='aboutus__staff'>
        <div className='aboutus__staff__column'>
          <div 
            ref={cardRefs[4]} 
            className="aboutus__staff__card tilting-card-body falling-card"
            onMouseEnter={(e) => handleMouseMove(e, cardRefs[4])} 
            onMouseMove={(e) => handleMouseMove(e, cardRefs[4])} 
            onMouseLeave={() => handleMouseLeave(cardRefs[4])}
          >
            <img src={staff_zen} alt="staff-bust-zen"/>
            <div id='staff_info'>
              <h3>Zenners</h3>
              <p>Narrative Writer</p>
              <a href='https://x.com/ZenFehr' target="_blank" rel="noreferrer">
                <i className="fa-brands fa-square-x-twitter"></i> ZenFehr
              </a>
            </div>
            {explosions[4] && <HexagonExplosion key={explosions[4].id} x={explosions[4].x} y={explosions[4].y} />}
          </div>
        </div>
        
        <div className='aboutus__staff__column'>
          <div 
            ref={cardRefs[5]} 
            className="aboutus__staff__card tilting-card-body falling-card"
            onMouseEnter={(e) => handleMouseMove(e, cardRefs[5])} 
            onMouseMove={(e) => handleMouseMove(e, cardRefs[5])} 
            onMouseLeave={() => handleMouseLeave(cardRefs[5])}
          >
            <img src={staff_chris} alt="staff-bust-chris"/>
            <div id='staff_info'>
              <h3>Chris Hill</h3>
              <p>Environmental Design</p>
            </div>
            {explosions[5] && <HexagonExplosion key={explosions[5].id} x={explosions[5].x} y={explosions[5].y} />}
          </div>
        </div>
  
        <div className='aboutus__staff__column'>
          <div 
            ref={cardRefs[6]} 
            className="aboutus__staff__card tilting-card-body falling-card"
            onMouseEnter={(e) => handleMouseMove(e, cardRefs[6])} 
            onMouseMove={(e) => handleMouseMove(e, cardRefs[6])} 
            onMouseLeave={() => handleMouseLeave(cardRefs[6])}
          >
            <img src={staff_john} alt="staff-bust-john"/>
            <div id='staff_info'>
              <h3>John Oestmann</h3>
              <p>Composer</p>
              <a href='https://johnoestmannmusic.com/' target="_blank" rel="noreferrer">
                <i className="fa-solid fa-globe"></i> johnoestmannmusic
              </a>
            </div>
            {explosions[6] && <HexagonExplosion key={explosions[6].id} x={explosions[6].x} y={explosions[6].y} />}
          </div>
        </div>  
  
        <div className='aboutus__staff__column'>
          <div 
            ref={cardRefs[7]} 
            className="aboutus__staff__card tilting-card-body falling-card"
            onMouseEnter={(e) => handleMouseMove(e, cardRefs[7])} 
            onMouseMove={(e) => handleMouseMove(e, cardRefs[7])} 
            onMouseLeave={() => handleMouseLeave(cardRefs[7])}
          >
            <img src={staff_andrew} alt="staff-bust-andrew"/>
            <div id='staff_info'>
              <h3>Andrew Farmer</h3>
              <p>Website Developer</p>
              <a href='https://www.afarmerstudio.com' target="_blank" rel="noreferrer">
                <i className="fa-solid fa-globe"></i> A. Farmer Studio
              </a>
            </div>
            {explosions[7] && <HexagonExplosion key={explosions[7].id} x={explosions[7].x} y={explosions[7].y} />}
          </div>
        </div>  
      </div>
    </div>
  );
};

export default AboutStaff;
